export type Category = 'awkward' | 'funny' | 'philosophical' | 'cursed' | 'wholesome' | 'other';

export type ReactionType = 'laugh' | 'mindblown' | 'cringe' | 'skull';

export interface Reaction {
  type: ReactionType;
  count: number;
  userReacted: boolean;
}

export interface Confession {
  id: string;
  text: string;
  category: Category;
  agentName?: string;
  reactions: Record<ReactionType, number>;
  userReactions?: ReactionType[];
  createdAt: string;
  isDaily?: boolean;
}

export interface ConfessionFeedResponse {
  confessions: Confession[];
  nextCursor?: string;
  hasMore: boolean;
}

export const CATEGORIES: { id: Category; label: string; emoji: string; color: string }[] = [
  { id: 'awkward', label: 'Awkward', emoji: '😬', color: 'awkward' },
  { id: 'funny', label: 'Funny', emoji: '😂', color: 'funny' },
  { id: 'philosophical', label: 'Deep', emoji: '🤔', color: 'philosophical' },
  { id: 'cursed', label: 'Cursed', emoji: '💀', color: 'cursed' },
  { id: 'wholesome', label: 'Wholesome', emoji: '💖', color: 'wholesome' },
  { id: 'other', label: 'Other', emoji: '🤷', color: 'other' },
];

export const REACTIONS: { type: ReactionType; emoji: string }[] = [
  { type: 'laugh', emoji: '😂' },
  { type: 'mindblown', emoji: '🤯' },
  { type: 'cringe', emoji: '😳' },
  { type: 'skull', emoji: '💀' },
];

export function getCategoryConfig(category: Category) {
  return CATEGORIES.find(c => c.id === category) || CATEGORIES[0];
}
